<template>
  <!-- 外层容器：宽100vw，高约41.93vw（805px转换），背景纯白 -->
  <div class="w-full h-auto py-[3.75vw] bg-white">
    <!-- 标题区域 -->
    <div
      class="relative w-full h-auto mx-auto mb-[1.71vw] flex flex-col justify-center gap-[0.42vw]"
    >
      <!-- 主标题框 -->
      <div class="h-[3.3vw] flex flex-col justify-center items-center">
        <div
          class="text-[2.71vw] text-[#1A2233] font-harmony font-bold leading-[3.25vw] text-center"
        >
          课程规划
        </div>
      </div>
      <!-- 副标题框 -->
      <div class="h-[3vw] flex flex-col justify-center items-center">
        <div
          class="text-[1.25vw] text-[#9CA3AF] font-harmony font-normal leading-[2.97vw] text-center"
        >
          三大课程体系，西北工业大学名师研发，有质量、有态度、有成绩
        </div>
      </div>
    </div>

    <!-- 内容框：宽约61.46vw（1180px转换），高约24.84vw（477px转换），距上侧约12.14vw（233px转换） -->
    <div class="w-[61.46vw] h-[24.84vw] mx-auto flex justify-between">
      <!-- 左半部分 -->
      <div class="w-[32.29vw] h-[24.84vw] relative">
        <!-- 使用 transition 包裹当前激活的部分 -->
        <transition name="fade" mode="out-in">
          <!-- 外层容器 -->
          <div
            v-if="currentPart"
            :key="activeTab"
            class="w-[32.29vw] h-[24.84vw] relative stage-card active"
          >
            <!-- 标题栏 -->
            <div
              class="w-[32.29vw] h-[1.61vw] p-[0.56vw] justify-center top-0 absolute rounded-sm inline-flex items-center"
              :style="{ backgroundColor: currentPart.titleBgColor }"
            >
              <div class="text-[0.73vw] text-white font-harmony">
                {{ currentPart.stageTitle }}
              </div>
            </div>

            <!-- 侧边标签（循环生成） -->
            <div
              v-for="(label, i) in currentPart.sideLabels"
              :key="i"
              :class="[label.layoutClass, commonSideLabelClass]"
              :style="{ backgroundColor: currentPart.titleBgColor }"
            >
              <div class="text-[0.73vw] text-white font-harmony">
                {{ label.text }}
              </div>
            </div>

            <!-- 结构框架：学段 -->
            <div
              class="w-[27.24vw] h-[5.10vw] left-[5.05vw] top-[2.08vw] absolute rounded-sm border-dashed border-[0.028vw] p-[0.83vw] flex flex-row justify-between items-centerr gap-[0.83vw]"
              :style="{
                borderColor: currentPart.titleBgColor,
                backgroundColor: currentPart.indexBgColor,
              }"
            >
              <div
                v-for="(item, i) in currentPart.structureItems"
                :key="i"
                class="h-full flex-auto min-w-0 flex flex-col justify-between gap-[0.26vw]"
              >
                <div
                  :class="activeBlockClass"
                  :style="{ backgroundColor: currentPart.titleBgColor }"
                >
                  {{ item.active }}
                </div>
                <div :class="inactiveBlockClass">
                  {{ item.inactive }}
                </div>
              </div>
            </div>

            <!-- 年龄 -->
            <div
              class="w-[27.22vw] h-[2.12vw] left-[5.07vw] top-[7.86vw] absolute rounded-sm border-dashed border-[0.028vw] px-[0.83vw] py-[0.33vw] flex flex-row justify-between items-center gap-[0.83vw]"
              :style="{
                borderColor: currentPart.titleBgColor,
                backgroundColor: currentPart.indexBgColor,
              }"
            >
              <div
                v-for="(age, i) in currentPart.ageItems"
                :key="i"
                :class="ageBlockClass"
                :style="{ backgroundColor: currentPart.titleBgColor }"
              >
                {{ age }}
              </div>
            </div>

            <!-- 年级 -->
            <div
              class="w-[27.22vw] h-[2.12vw] left-[5.07vw] top-[10.47vw] absolute rounded-sm border-dashed border-[0.028vw] px-[0.83vw] py-[0.33vw] flex flex-row justify-between items-center"
              :style="{
                borderColor: currentPart.titleBgColor,
                backgroundColor: currentPart.indexBgColor,
              }"
            >
              <div
                :class="gradeBlockClass"
                :style="{ backgroundColor: currentPart.titleBgColor }"
              >
                {{ currentPart.gradeText }}
              </div>
            </div>

            <!-- 培养能力 -->
            <div
              class="w-[27.24vw] h-[5.10vw] left-[5.05vw] top-[13.13vw] absolute rounded-sm border-dashed border-[0.028vw] p-[0.83vw] flex flex-row justify-between items-center"
              :style="{
                borderColor: currentPart.titleBgColor,
                backgroundColor: currentPart.indexBgColor,
              }"
            >
              <div
                class="h-full w-full flex flex-col justify-between gap-[0.26vw]"
              >
                <div
                  v-for="(item, i) in currentPart.cultivationItems"
                  :key="i"
                  :class="i === 0 ? activeBlockClass : inactiveBlockClass"
                  :style="
                    i === 0 ? { backgroundColor: currentPart.titleBgColor } : {}
                  "
                >
                  {{ item }}
                </div>
              </div>
            </div>

            <!-- 学习目标 -->
            <div
              class="w-[27.24vw] h-[6.25vw] left-[5.05vw] top-[18.59vw] absolute rounded-sm border-dashed border-[0.028vw] px-[0.83vw] py-[0.68vw] flex flex-row justify-between items-center"
              :style="{
                borderColor: currentPart.titleBgColor,
                backgroundColor: currentPart.indexBgColor,
              }"
            >
              <div
                class="self-stretch flex items-start justify-start text-[#333333] text-[0.63vw] text-start font-normal font-harmony leading-[0.94vw] whitespace-pre-line"
              >
                {{ currentPart.objectives.replace(/^\s+|\s+$/g, "") }}
              </div>
            </div>
          </div>
        </transition>
      </div>

      <!-------------------------------------------------------------------------------------------->
      <!-- 右半部分整体容器 -->
      <div
        class="w-[28.13vw] h-[24.84vw] flex flex-col justify-between gap-[1.04vw] ml-[1.04vw]"
      >
        <!-- 遍历所有选项卡 -->
        <div
          v-for="(tab, index) in tabs"
          :key="index"
          :class="commonStageCardClass"
          :style="{
            backgroundColor: activeTab === index ? tab.activeBg : tab.defaultBg,
            flex: activeTab === index ? '1 1 60%' : '1 1 20%',
          }"
          @mouseenter="activeTab = index"
        >
          <!-- 标题，动态绑定颜色 -->
          <div
            :class="[
              commonTitleClass,
              activeTab === index ? 'text-white' : 'text-black',
            ]"
          >
            {{ tab.title }}
          </div>
          <!-- 描述，动态绑定颜色 -->
          <div
            :class="[
              commonDescClass,
              activeTab === index ? 'text-white' : 'text-[#9CA3AF]',
            ]"
            style="line-height: 1.09vw"
          >
            {{ tab.description }}
          </div>
          <!-- 标签区域：只有当前激活时显示 -->
          <div
            class="flex flex-wrap gap-[0.52vw] pt-[0.52vw]"
            v-show="activeTab === index"
          >
            <div v-for="(tag, i) in tab.tags" :key="i" :class="commonTagClass">
              <div
                :class="commonTagTextClass"
                :style="{ color: currentPart.titleBgColor }"
              >
                {{ tag }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home-module4",
  data() {
    return {
      activeTab: 0,
      // 右侧内容区
      tabs: [
        {
          title: "基础阶段",
          description:
            "小学按年级设“三、四、五”不同年级学习内容。主要以“培养兴趣、激发好奇心、基础知识拓展、提高专注力”等为学生小学段学习目标。",
          activeBg: "#05358C",
          defaultBg: "#F5F5F7",
          tags: ["认识航空器", "兴趣培养", "培养专注力", "竞技比赛"],
        },
        {
          title: "提高阶段",
          description:
            "基于初一、二学科架构，结合数学、物理等知识，通过组装LANYVE航空模型，学习组装、焊接、调参调试技术,了解结构部件的工作原理，培养学生逻辑思维和系统性协作思维。",
          activeBg: "#F28334",
          defaultBg: "#F5F5F7",
          tags: ["理论学习", "飞机组装", "焊接调试", "飞行实践", "飞行比赛"],
        },
        {
          title: "创意阶段",
          description:
            "公司自研创新教材，细分航空器分系统构成及工作原理，深度讲解航空器各系统涉及的专业范畴及专业发展方向，让学生提前学习航空器分系统的专业软件，参与航空器创意创新设计，培养独立思考能力和创新决策能力。",
          activeBg: "#05358C",
          defaultBg: "#F5F5F7",
          tags: ["理论学习", "总体设计", "智能控制", "系统仿真", "设计比赛"],
        },
      ],
      // 左侧内容区
      parts: [
        {
          tabName: "第一部分",
          stageTitle: "基础阶段",
          titleBgColor: "#05358C", // 标签背景色
          indexBgColor: "#EBF4FF", // 框架背景色
          sideLabels: [
            {
              text: "学段",
              layoutClass: "w-[4.48vw] h-[5.10vw] justify-center top-[2.08vw]",
            },
            {
              text: "培养能力",
              layoutClass: "w-[4.48vw] h-[5.10vw] justify-center top-[13.13vw]",
            },
            {
              text: "学习目标",
              layoutClass: "w-[4.48vw] h-[6.25vw] justify-center top-[18.59vw]",
            },
            {
              text: "年龄",
              layoutClass: "w-[4.45vw] h-[2.12vw] justify-center top-[7.86vw]",
            },
            {
              text: "年级",
              layoutClass: "w-[4.45vw] h-[2.12vw] justify-center top-[10.47vw]",
            },
          ],
          structureItems: [
            { active: "航空探秘-航模篇", inactive: "认识航空器" },
            { active: "航空探秘-无人机Ⅰ篇", inactive: "探索飞行组装" },
            { active: "航空探秘-无人机Ⅱ篇", inactive: "知识拓展" },
          ],
          ageItems: ["8-9岁", "9-10岁", "10-12岁"],
          gradeText: "小学段",
          cultivationItems: ["培养好奇心和兴趣", "提高思维专注能力"],
          objectives:
            "1. 科普知识、认识航空器的发展、分类、掌握基础知识；\n2. 进行简易航空器手工制作激发学习兴趣；\n3. 探索航空器的飞行原理及构成，引导思考与探究；\n4. 无人机遥控模拟训练，提高专注力及协调能力；\n5. 参加航空飞行赛事，定制目标、塑造竞争意识。",
        },
        {
          tabName: "第二部分",
          stageTitle: "提高阶段",
          titleBgColor: "#F28334",
          indexBgColor: "#FFF6EB",
          sideLabels: [
            {
              text: "学段",
              layoutClass: "w-[4.48vw] h-[5.10vw] justify-center top-[2.08vw]",
            },
            {
              text: "培养能力",
              layoutClass: "w-[4.48vw] h-[5.10vw] justify-center top-[13.13vw]",
            },
            {
              text: "学习目标",
              layoutClass: "w-[4.48vw] h-[6.25vw] justify-center top-[18.59vw]",
            },
            {
              text: "年龄",
              layoutClass: "w-[4.45vw] h-[2.12vw] justify-center top-[7.86vw]",
            },
            {
              text: "年级",
              layoutClass: "w-[4.45vw] h-[2.12vw] justify-center top-[10.47vw]",
            },
          ],
          structureItems: [
            { active: "L4", inactive: "技能-航空器" },
            { active: "L5", inactive: "创新-航空器" },
          ],
          ageItems: [" 8-9岁 ", "9-10岁 "].map((age) =>
            age.replace(/ /g, "\u00A0")
          ),
          gradeText: "初中段",
          cultivationItems: ["培养系统性思维", "提高系统协作能力"],
          objectives:
            "1. 学习航空原理导入“数学、物理”知识；\n2. 掌握机械拆装、改装及电气焊接、调试等技能；\n3. 学习编程知识，初探自动化专业，培养逻辑性思维与系统性思维；\n4. 参加航空航天创意类比赛，挖掘闪光点，收获荣誉。",
        },
        {
          tabName: "第三部分",
          stageTitle: "创意阶段",
          titleBgColor: "#05358C",
          indexBgColor: "#EBF4FF",
          sideLabels: [
            {
              text: "学段",
              layoutClass: "w-[4.48vw] h-[5.10vw] justify-center top-[2.08vw]",
            },
            {
              text: "培养能力",
              layoutClass: "w-[4.48vw] h-[5.10vw] justify-center top-[13.13vw]",
            },
            {
              text: "学习目标",
              layoutClass: "w-[4.48vw] h-[6.25vw] justify-center top-[18.59vw]",
            },
            {
              text: "年龄",
              layoutClass: "w-[4.45vw] h-[2.12vw] justify-center top-[7.86vw]",
            },
            {
              text: "年级",
              layoutClass: "w-[4.45vw] h-[2.12vw] justify-center top-[10.47vw]",
            },
          ],
          structureItems: [
            { active: "L6", inactive: "设计-航空器" },
            { active: "L7", inactive: "创意-航空器" },
          ],
          ageItems: [" 14-16岁", "16-18岁"].map((age) =>
            age.replace(/ /g, "\u00A0")
          ),
          gradeText: "高中段",
          cultivationItems: ["培养独立思考能力", "提高创新决策能力"],
          objectives:
            "1. 系统性认识航空器，掌握航空器分系统工作原理；\n2. 了解航空器分系统涉及的专业知识及应用方向；\n3. 结合兴趣爱好，选择专业设计软件深入学习，为大学专业学习提供支持；\n4. 参加飞行器创意类设计大赛，增加技能背书。",
        },
      ],
    };
  },
  computed: {
    // 右侧内容区
    // 外层选项卡公共 class（保持原有布局相关的 class 不变）
    commonStageCardClass() {
      return "px-[1.25vw] pb-[1.25vw] pt-[0.83vw] rounded-[0.52vw] flex flex-1 flex-col justify-between stage-card cursor-default";
    },
    // 标题文字的公共 class
    commonTitleClass() {
      return "text-[1.04vw] font-harmony font-bold mb-[0.42vw]";
    },
    // 描述文字的公共 class
    commonDescClass() {
      return "text-[0.73vw] font-regular font-harmony leading-[1.09vw]";
    },
    // 标签容器的公共 class（这里直接在模板写了 flex flex-wrap gap-[0.52vw] pt-[0.52vw]）
    // 如需复用，也可提取为 computed
    // 每个标签的容器公共 class
    commonTagClass() {
      return "px-[0.42vw] py-[0.21vw] bg-[#FFFFFF] rounded-sm";
    },
    // 标签内部文字的公共 class
    commonTagTextClass() {
      return "text-[0.63vw]  font-regular font-harmony";
    },
    // 左侧内容区
    // 侧边标签内部文本样式（不含布局）
    commonTextClass() {
      return "text-[0.73vw] text-white font-harmony";
    },
    // 侧边标签容器公共样式（除布局部分外）
    commonSideLabelClass() {
      // 注意：这里不直接写背景色，背景色由 part.titleBgColor 动态绑定
      return "p-[0.56vw] absolute rounded-sm inline-flex items-center";
    },
    // 结构框架内上半部分模块样式
    activeBlockClass() {
      // 注意：这里不直接写背景色，背景色由 part.titleBgColor 动态绑定
      return "h-full px-[0.33vw] py-[0.11vw] rounded-sm text-[0.63vw] text-white font-harmony flex items-center justify-center";
    },
    // 结构框架内下半部分模块样式
    inactiveBlockClass() {
      return "h-full px-[0.33vw] py-[0.11vw] bg-white rounded-sm text-[0.63vw] text-[#333] font-harmony flex items-center justify-center";
    },
    // 年龄模块中每个子项的公共样式
    ageBlockClass() {
      return "h-full flex-auto min-w-0 flex flex-row px-[0.62vw] py-[0.5vw]  text-center text-[0.625vw] text-[#FFFFFF] font-harmony font-normal items-center justify-center";
    },
    // 年级模块的公共样式
    gradeBlockClass() {
      return "h-full w-full flex px-[0.62vw] py-[0.5vw] text-center text-[0.625vw] text-[#FFFFFF] font-harmony font-normal items-center justify-center";
    },
    // 当前激活的左侧部分（用于动画切换）
    currentPart() {
      return this.parts[this.activeTab];
    },
  },
};
</script>

<style scoped>
/* 自定义过渡效果 */
.stage-card {
  transition-property: background-color, transform, opacity; /* 定义需要过渡的属性 */
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1); /* 过渡时间函数 */
  transition-duration: 600ms; /* 过渡持续时间 */
}

/* 激活状态 */
.stage-card.active {
  transition-timing-function: cubic-bezier(
    0.4,
    0,
    0.2,
    1
  ); /* 激活状态的时间函数 */
}

/* 非激活状态 */
.stage-card:not(.active) {
  opacity: 0.8; /* 非激活状态的透明度 */
  transform: scale(0.98); /* 非激活状态的缩放比例 */
}

/* 添加字体渲染优化 */
.stage-card {
  -webkit-font-smoothing: subpixel-antialiased; /* 字体抗锯齿 */
  backface-visibility: hidden; /* 隐藏背面 */
  transform: translateZ(0); /* 启用硬件加速 */
}

/* 淡入淡出动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 280ms cubic-bezier(0.33, 1, 0.68, 1),
    transform 280ms cubic-bezier(0.33, 1, 0.68, 1); /* 定义淡入淡出动画 */
  will-change: opacity, transform; /* 提示浏览器优化 */
}

/* 进入开始状态 */
.fade-enter {
  opacity: 0; /* 初始透明度 */
  transform: translateY(-4px) scale(0.99); /* 初始位置和缩放 */
}

/* 进入结束状态 */
.fade-enter-to {
  opacity: 1; /* 最终透明度 */
  transform: translateY(0) scale(1); /* 最终位置和缩放 */
}

/* 离开结束状态 */
.fade-leave-to {
  opacity: 0; /* 最终透明度 */
  transform: translateY(4px) scale(0.99); /* 最终位置和缩放 */
}
</style>
